import { PromptBadge } from "@/components/prompt-badge"

export interface MetaBiteProps {
  text: string
  name: string
  title: string
  clarity?: "success" | "warning" | "caution" | "critical"
}

export const MetaBite = ({ title, name, text, clarity }: MetaBiteProps) => {
  return (
    <article className="flex flex-col gap-3">
      <div className="flex justify-between text-xl font-semibold text-[#B9B9B9]">
        <h3>{title}</h3>
        {clarity && <PromptBadge variant={clarity} />}
      </div>
      <textarea
        value={text}
        name={name}
        className="flex field-sizing-content h-full resize-none appearance-none border-none bg-transparent p-0 text-lg leading-8 font-normal text-black outline-none"
      />
    </article>
  )
}
